import React, { useState, useRef, useEffect } from "react";
import { MdOutlineLogout } from "react-icons/md";
import { IoPersonOutline } from "react-icons/io5";

import { CgProfile } from "react-icons/cg";
import { IoMdNotificationsOutline } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import SearchBar from "./SearchBar";
import axios from "axios";
import { useUser } from "../context/UserContext";
import api from "../utils/api";

function NavBar() {
  const navigate = useNavigate();
  const { currentUser, loading, setCurrentUser } = useUser(); // Add loading from useUser
  const [showNotification, setShowNotification] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [notifications] = useState([]);
  const notifRef = useRef();
  const profileRef = useRef();

  // Handle search and suggestions

  const handleLogout = () => {
  localStorage.removeItem("token");  // remove JWT
  setCurrentUser(null);              // clear user state
  navigate("/login");                // redirect
};



  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notifRef.current && !notifRef.current.contains(event.target)) {
        setShowNotification(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfile(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (loading) {
    return (
      <div className="h-16 flex items-center justify-between px-6 relative">
        <motion.img
          src="/companylogo.png"
          alt="Company"
          className="h-10 w-auto mb-2"
        />
        <div className="flex items-center gap-6">
          <div className="h-8 w-8 rounded-full animate-pulse bg-slate-200"></div>
          <div className="h-8 w-8 rounded-full animate-pulse bg-slate-200"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="h-16 flex items-center justify-between px-6  relative">
      {/* Greeting */}

      <motion.img
        src="/companylogo.png"
        alt="Company"
        className="h-10 w-auto mb-2"
        transition={{ duration: 0.8 }}
        whileHover={{ scale: 1.1 }}
      />

      {/* Search, Notifications, Profile */}
      <div className="flex items-center gap-6 relative">
        {/* Search Box */}
        <div className="sm:block hidden">
          <SearchBar />
        </div>
        {/* Notifications */}
        <div ref={notifRef} className="relative">
          <button
            onClick={() => setShowNotification(!showNotification)}
            aria-label="Toggle notifications"
            className="text-gray-700 hover:text-indigo-600 transition relative"
          >
            <IoMdNotificationsOutline className="text-3xl" />
            {notifications.length > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
                {notifications.length}
              </span>
            )}
          </button>
          {showNotification && (
            <div className="absolute right-0 mt-2 w-64 bg-white border border-gray-200 shadow-xl rounded-lg p-4 z-10">
              <h2 className="font-semibold mb-2 text-gray-800">
                Notifications
              </h2>
              <spam className="text-slate-400">No notifications</spam>
            </div>
          )}
        </div>

        {/* Profile */}
        <div ref={profileRef} className="relative">
          <button
            onClick={() => setShowProfile(!showProfile)}
            aria-label="Toggle profile menu"
            className="text-gray-700 hover:text-indigo-600 transition"
          >
            <CgProfile className="text-3xl" />
          </button>
          {showProfile && (
            <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 shadow-xl rounded-lg p-4 z-10 text-sm">
              <button
                onClick={() => {
                  setShowProfile(false);
                  navigate("/admin/profile");
                }}
                className=" flex pl-4 justify-start items-center gap-2 w-full text-lg hover:bg-gray-100 hover:rounded-full p-1 rounded"
              >
                <IoPersonOutline /> Profile
              </button>
              <button
                onClick={handleLogout}
                className="flex justify-start pl-4 items-center gap-2 w-full text-lg text-red-500 hover:bg-gray-100 hover:rounded-full  p-1 rounded"
              >
                <MdOutlineLogout /> Log out
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default NavBar;
